import { OldPortfolio, UserPerms, WebUserDataConstants } from '@ddt-web/domain';


export class PortfolioModelUtil {
	/**
	 * @description Takes an array and based on the rebalanceNotification field
	 * figures out which lastModifiedDate to use and uses that to sort the array
	 * @param  {Array<any>} portfolios
	 * @returns Array
	 */
	public static sortModifiedByAscending(portfolios: Array<any>): Array<any> {
		return portfolios.sort((p1, p2) => {
			if (p1.rebalanceNotification || p2.rebalanceNotification) {
				if (p1.rebalanceNotification && p2.rebalanceNotification) {
					return p2.getBaseModel().lastModifiedDate - p1.getBaseModel().lastModifiedDate;
				}
				if (p1.rebalanceNotification) {
					return p2.lastModifiedDate - p1.getBaseModel().lastModifiedDate;
				}
				if (p2.rebalanceNotification) {
					return p2.getBaseModel().lastModifiedDate - p1.lastModifiedDate;
				}
			} else {
				return p2.lastModifiedDate - p1.lastModifiedDate;
			}
		});
	}

	public static isCustomPortfolio(portfolio: OldPortfolio): boolean {
		return portfolio.getSubType() !== WebUserDataConstants.SUBTYPE.SAMPLE;
	}

	public static removeSamplePortfolios(portfolios: Array<OldPortfolio>): Array<OldPortfolio> {
		const containsCustomPortfolios = portfolios.some(PortfolioModelUtil.isCustomPortfolio);
		return containsCustomPortfolios ? portfolios.filter(PortfolioModelUtil.isCustomPortfolio) : portfolios;
	}

	public static setModifiedByDifferentUser(currentUser: string, portfolio: OldPortfolio): OldPortfolio {
		portfolio.setModifiedByDifferentUser(portfolio.getLastModifyingUser() !== '' && portfolio.getLastModifyingUser() !== currentUser);
		return portfolio;
	}

	public static setCreatedByDifferentUser(currentUser: string, portfolio: OldPortfolio): OldPortfolio {
		portfolio.setCreatedByDifferentUser(portfolio.getOwner() !== '' && portfolio.getOwner() !== currentUser);
		return portfolio;
	}

	public static getUserPerms(portfolioData: any): UserPerms {
		return new UserPerms(portfolioData.allowedPermsForCurrentUser);
	}
}
